export default __webpack_public_path__ + "static/media/ucsb.2967b2a8.jpg";